<template>
  <div class="account-right-item attention">
    <h4>收藏用户</h4>
    <loading :ifLoadingStart="isLoading" style="padding: 100px 0"></loading>
    <div v-if="!isLoading">
      <div v-if="page.total!=0">
        <ul class="wrapper-list clearfix">
          <li class="clearfix" v-for="item in attention_list">
            <a href="javascript:;" class="fl images-box">
              <img :src="item.avatar_url" alt="" width="60" height="60" v-if="item.avatar_url.indexOf('?')!==0" />
              <img src="../../../images/personal_center/avatar_default.png" alt="" width="60" height="60" v-else/>
            </a>
            <div class="fl info-box">
              <a href="javascript:;">
                <h5 class="toe" :title="item.nick_name">{{item.nick_name}}</h5>
              </a>
              <p v-if="!item.isCancel">{{item.focus.day}}收藏了该作品</p>
              <p v-if="item.isCancel">刚刚取消收藏了该作品</p>
              <p v-show="!item.isCancel">
                <span v-if="item.each_other == 1">
                  <span class="icon "></span>
                  互相关注，
                </span>
                <span v-if="item.each_other == 0">
                  <span class="icon focused"></span>
                  已关注，
                </span>
                <a href="javascript:;" v-on:click="doCancel(item)">取消</a>
                <a href="javascript:;" @click="showBox(item.user_id, item.nick_name)">留言</a>
              </p>
              <p v-show="item.isCancel">
                <span class="follow" v-on:click="doAdd(item)">
                  <span class="icon focus"></span>
                  关注TA
                </span>
              </p>
            </div>
          </li>
        </ul>
        <button type="button" class="load-more" v-on:click="doLoadMore" v-show="page.totalPage > 1" :disabled="use">
          {{load_more}}
        </button>
      </div>
      <div class="attention-null" v-else>
        <img src="../../../images/personal_center/work-null.png" alt="" />
        <p>未有人收藏该作品,要加把劲哦！</p>
      </div>
    </div>
    <!-- 留言框 -->
    <div class="attention-pops" v-if="msgBox.status">
      <div class="pops-content">
        <div class="message">
          <h4>给 <router-link class="user" :to="{path:'/s-mart/personal/'+msgBox.user_id+'/'}">{{msgBox.nick_name}}</router-link> 留言<a class="fr pops-close" href="javascript:;" @click="closeBox"><img src="../../../images/personal_center/pops-close.png" alt="" /></a></h4>
          <div class="msg-box">
            <textarea class="msg" placeholder="在此输入你的留言内容..." name="msg" v-model="msg.content" maxlength="200"></textarea>
          </div>
          <div class="send clearfix" v-if="msg_list[msgBox.user_id].status">
            <p v-if="200-msg.content.length>=0">还可以输入 <span class="number">{{200 - msg.content.length}}</span> 个字符</p>
            <p v-else>已超出 <span class="number">{{msg.content.length - 200}}</span> 个字符</p>
            <a class="send-msg" href="javascript:void(0);" @click="sendMsg" v-if="!msg.isSubmit">发送</a>
            <a class="send-msg" href="javascript:void(0);" v-else><img class="loading" src="../../../images/common/loading_16.svg" alt="">提交中</a>
          </div>
          <div class="wait" v-else>
            发送留言成功，<span class="time">{{curCount.count | formatTime}}</span>后可继续留言
          </div>
        </div>
      </div>
    </div>
    <v-alert :options="options"></v-alert>
  </div>
</template>

<script type="text/javascript">
  import vAlert from "../../alert.vue";
  import loading from '../../loading.vue';
  export default {
    filters: {
      formatTime(data) {
        if (data < 60) {
          return data + "秒";
        }else if(data < 70){
          return "1分0" + (data - 60) + "秒";
        }else {
          return "1分" + (data - 60) + "秒";
        }
      }
    },
    data() {
      return {
        isLoading: true,
        attention_list:[],//获取关注列表
        attention_num: "",//我关注的人数
        load_more:"加载更多",
        seen:false,//未关注任何人是否课件
        options:{
          page:1
        },
        use:false, //是否可用
        page: {},
        msgBox: {      // 留言弹窗
          status: false,   // 是否显示留言框,
          nick_name: '',
          user_id: ''
        },
        msg: {    // 消息相关
          content: '',
          isSubmit: false,  //是否处于提交中
          during: 119,  // 2分钟发一次
        },
        curCount: {  //当前定时器相关
          count: 0,       // 当前计时
          timer: null,   // 定时器
          status: false  // 是否可留言
        },
        msg_list: {},  // 定时器列表

        options: {}
      }
    },
    methods:{
      sendMsg() {  // 留言
        if (this.msg.content.length<=0) {
          this.options = {
            msgIsSuccess: false,
            msgText: "请输入留言内容"
          }
          return ;
        }
        if (this.msg.content.trim() === "") {
          this.options = {
            msgIsSuccess: false,
            msgText: "输入内容不能为空"
          }
          return ;
        }
        if (this.msg.content.length>200) {
          this.options = {
            msgIsSuccess: false,
            msgText: "内容长度不合法"
          }
          return ;
        }
        let uid = this.msgBox.user_id;
        this.msg.isSubmit = true;
        axios.post(myUrl + "sns/message/leave/" + this.msgBox.user_id + "/", qs.stringify({
          content: this.msg.content
        })).then((res) => {
          res = res.data;
          if (res.result) {
            let curMsg = this.msg_list[uid];
            curMsg.status = false;
            curMsg.count = this.msg.during;
            curMsg.timer = setInterval(() => {
              curMsg.count--;
              if (curMsg.count <= 0) {
                clearInterval(curMsg.timer);
                curMsg.count = this.msg.during;
                curMsg.timer = null;
                curMsg.status = true;
              }
            }, 1000)
            this.curCount = this.msg_list[uid];
          }else {
            this.options = {
              msgText: "留言失败，请稍后重试",
              msgIsSuccess: false
            }
          }
          this.msg.isSubmit = false;
        }).catch(() => {
          this.msg.isSubmit = false;
        })
      },
      /*
        nick_name: 对话框用户名,
        user_id: 对话框用户id
      */
      showBox(user_id, nick_name) {
        this.msgBox.nick_name = nick_name;
        this.msgBox.user_id = user_id;
        this.msgBox.status = true;  // 显示留言框
        if (!this.msg_list[user_id]) {
          this.msg_list[user_id] = {
            status: true,
            count: this.msg.during,
            timer: null
          }
        }
        this.curCount = this.msg_list[user_id];
      },
      /*留言*/
      closeBox() {
        this.msg.content = '';
        this.msgBox.status = false;  // 关闭留言框
      },
      getAttentionList(){ //获取默认关注页
        this.isLoading = true;
        let app_id = this.$route.params.wid;
        axios.get(myUrl + `sns/collect_user/product/${app_id}/`).then((res) => {
            res = res.data;
            if(res.result){
              this.attention_num = res.data.page.total;
              this.page = res.data.page;
              if(res.data.items.length == 0){
                this.seen = true;
              }else {
                if (res.data.page.curPage == res.data.page.totalPage){
                  this.load_more = "没有更多内容了";
                  this.use = true;
                }
                for (var i = 0 ; i < res.data.items.length ; i++){//添加isCancel属性
                  res.data.items[i]['isCancel'] = false;
                }
                this.attention_list = res.data.items;
              }
              this.isLoading = false;
            } else {
              console.log(res.message);
            }
        });
      },
      doCancel(item){//取消关注
        axios.post(myUrl + "sns/unstar/user/"+item.user_id+"/").then((res) => {
            res = res.data;
            if(res.result){
                this.attention_num --;
                item.isCancel = !item.isCancel;
            } else {
              console.log(res.message);
            }
        });
      },
      doAdd(item){//加关注
        axios.post(myUrl + "sns/star/user/"+item.user_id+"/").then((res) => {
          res = res.data;
          if(res.result){
            this.attention_num ++;
            item.isCancel = !item.isCancel;
            item.focus.day = "刚刚";
          } else {
            console.log(res.message);
          }
        });
      },
      doLoadMore(){ //显示更多
        var newOption = this.options;
        newOption.page++;
        var qs = require('qs');
          axios.post(myUrl + "sns/star/user/",qs.stringify(newOption)).then((res)=>{
            res =  res.data;
            if (res.result){
                this.attention_list = this.attention_list.concat(res.data.items);
                if(res.data.page.curPage == res.data.page.totalPage){
                  this.load_more = "没有更多内容了";
                  this.use = true;
                }
            } else {
              console.log(res.message);
            }
          });
      },
    },
    created() {
      this.getAttentionList();
    },
    components: {
      vAlert,
      loading
    }
  }
</script>

<style media="screen" lang="scss">
  .attention{
    min-height: 650px;
    padding: 15px 45px 45px;
    >h4{
      padding: 18px 0;
      font-size: 18px;
      font-weight: bold;
      color: #77787f;
      border-bottom: 1px solid #f4f4f4;
      span{
        font-weight: normal;
        font-size: 14px;
      }
    }
    .wrapper-list{
      margin: 28px 0 0;
      li+li{
        margin-left: 20px;
      }
      li:nth-child(3n+1){
        margin-left: 0px;
      }
      li{
        display:block;
        float: left;
        width: 260px;
        height: 90px;
        padding: 14px;
        border: 1px solid #dddddd;
        margin-bottom: 20px;
        position: relative;
        .follow{
          cursor: pointer;
        }
        .images-box{
          margin-right: 12px;
        }
        .info-box{
          width: 158px;
        }
        h5{
          color: #444444;
          margin: 2px 0;
        }
        p{
          color: #aaaaaa;
          font-size: 12px;
          margin-bottom: 5px;
          .follow{
            cursor: pointer;
          }
          .icon{
            display: inline-block;
            vertical-align: -2px;
            width: 13px;
            height: 13px;
            background: url(../../../images/personal_center/attention-each.png)no-repeat center center;
            &.focused{
              background-image: url(../../../images/personal_center/attention.png);
            }
            &.focus{
              background-image: url(../../../images/personal_center/attention-add.png);
            }
          }
          .focus-on{
            color: #aaaaaa;
          }

        }
        a{
          color: #57a3f1;
        }
        &:hover{
          border: 1px solid #57a3f1;
          outline: 1px solid #57a3f1;
        }
      }
    }
    .load-more{
      display:block;
      width: 100%;
      height: 42px;
      line-height: 42px;
      border: 1px solid #f4f4f4;
      text-align: center;
      font-size: 14px;
      color: #828282;
      background: #fff;
      cursor: pointer;
      &:focus{
        outline: none;
      }
      &:hover{
        background: #fafafa;
      }
    }

    .attention-pops{
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background: rgba(0,0,0,.3);
      z-index: 10000;
      .pops-content{
        width: 746px;
        height: 264px;
        padding: 20px 24px;
        background: #fff;
        position: absolute;
        left: 50%;
        top:50%;
        transform:translate(-50%,-50%);
        h4{
          padding: 0 0 20px 0;
          font-size: 16px;
          color: #090b1a;
          border-bottom: 1px solid #f4f4f4;
        }
        .message{
          .user{
            color: #57a3f1;
          }
          .msg-box{
            margin-top: 19px;
            .msg{
              border: 1px solid #e5e5e5;
              padding:13px;
              width: 100%;
              height: 120px;
              color: #666;
              resize: none;
            }
          }
          .send{
            margin-top: 13px;
            line-height: 30px;
            p{
              float: left;
              color: #adadb2;
              font-size: 12px;
            }
            .number{
              font-weight: bold;
              color: #57a3f1;
            }
            .send-msg{
              float: right;
              width: 90px;
              height: 30px;
              background: #57a3f1;
              text-align: center;
              color: #fff;
              border: 1px solid #4e92d8;
              .loading{
                margin-top: -2px;
                margin-right: 5px;
              }
            }
          }
          .wait{
            display: block;
            font-size: 12px;
            color: #444444;
            text-align: right;
            margin-top: 15px;
            .time{
              color: #57a3f1;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// collect_user.vue?6e41470d